<template>
  <div class="row">
      <breadcrumb-component
          :moduleTitle="'Service management'"
          :mainTitle="'Disk'"
          :subTitle="'Disk create'"
      />
      <div class="col-md-12">
          <div class="card card_full_window vm_checkout_page ">
              <div class="card-body">
                <template v-if="selectedService?.slug === 'vlan24-cloud'">
                  <VlanCloudDiskForm />
                </template>
                <template v-else>
                  <CloudDiskForm />
                </template>
              </div>
          </div>
      </div>
  </div>
</template>
  
<script>
  import {mapGetters} from "vuex";
    import BreadcrumbComponent from '@/components/shared/BreadcrumbComponent.vue';
  import VlanCloudDiskForm from "@/views/services/cloud_disks/VlanCloudDiskForm.vue";
  import CloudDiskForm from "@/views/services/cloud_disks/CloudDiskForm.vue";
    export default {
        name: 'create-cloud-disk-form',
        components: {CloudDiskForm, VlanCloudDiskForm, BreadcrumbComponent},
        data(){
            return {
              selectedService: null
            }
        },
      computed:{
        ...mapGetters({
          customer: 'auth/getUserInfo',
          services: 'auth/getCustomerServices',
        }),
      },
      watch: {
        customer: {
          handler(newVal, oldVal) {
            if (newVal?.selected_service_id !== oldVal?.selected_service_id) {

              // Perform actions when selected_service_id changes
              const newService = this.services.find((item) => item.id === parseInt(newVal?.selected_service_id));
              if (newService) {
                this.selectedService = newService
              } else {
                console.log('No matching service found');
              }
            }
          },
          deep: true, // Watch for changes in nested properties
          immediate: true, // Optional: Run the watcher immediately on component creation
        },
      },
    }
</script>
<style scoped>

</style>
  